import { useContext, useEffect, useMemo, useState } from "react";
import {
  Pagination,
  Search,
  TableHeader,
} from "../../../context/components/DataTable";
import LoaderContext from "../../../context/loader/LoaderContext";
import { Link, useNavigate } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import axiosPrivate from "../../../hooks/axiosPrivate";
import AuthContext from "../../../context/Auth/AuthContext";
import { GrView } from "react-icons/gr";

function isValidURL(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

const OrderTable = ({ headers }) => {
  const { setIsLoading } = useContext(LoaderContext);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const filterListLengths = [10, 25, 50, 100];
  const [orderState, setOrderState] = useState([]);
  const { checkPermissionExists, authPermissions } = useContext(AuthContext);
  const navigate = useNavigate();

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  }

  const orderList = () => {
    if (!search) {
      setIsLoading(true);
    }

    axiosPrivate
      .get(
        `orders/paginated?page=${currentPage}&limit=${itemsPerPage}&search=${debouncedSearch}`,
      )
      .then((orders) => {
        const ordersData = orders?.data?.data?.map((value, key) => {
          let order_status_1;

          order_status_1 =
            value.order_status === "confirmed" ? (
              <button
                className="tag  button-status"
                style={{ background: "#b6cb43", color: "white" }}
              >
                Confirmed
              </button>
            ) : value.order_status === "cancelled" ? (
              <button
                className="tag  button-status"
                style={{ background: "#5a6268", color: "white" }}
              >
                Cancelled
              </button>
            ) : (
              <button className="tag tag-warning button-status">Pending</button>
            );
          value["order_no"] = "#" + value?.order_no;
          value["order_status_2"] = value?.order_status;

          value["order_status"] = order_status_1;
          value["order_date"] = formatDate(value?.order_date);
          value["order_punched_by"] =
            value.order_punched_by == "admin"
              ? "Admin"
              : value.order_punched_by == "area_manager"
                ? "Area Manager"
                : value.order_punched_by == "dealer"
                  ? "Dealer"
                  : "";

          value["action"] = "-";
          //   value["roles"] = toTitleCase(value.roles);
          return value;
        });
        setTotalItems(orders?.data?.total);
        setOrderState(ordersData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("errorr", error);
        setIsLoading(false);
      });
  };

  const changeItemsPerPage = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    orderList();
  }, [authPermissions, currentPage, itemsPerPage, debouncedSearch]);

  const newData = orderState.map((value, key) => {
    let buttons = [];
    buttons.push(
      (value.order_status_2 == "to_logistics" ||
        value.order_status_2 == "confirmed" ||
        value.order_status_2 == "cancelled") &&
        authPermissions.includes("Order-View") ? (
        <Link
          key={`viewButton##${key}`}
          type="button"
          to={`/admin/order/edit/${value.order_uid}`}
          className="btn btn-icon"
          // title="Edit"
        >
          <GrView style={{ color: "blue" }} size={18} />
        </Link>
      ) : // Change to view icon
      authPermissions.includes("Order-Edit") ? (
        <Link
          key={`editButton##${key}`}
          type="button"
          to={`/admin/order/edit/${value.order_uid}`}
          className="btn btn-icon"
          // title="Edit"
        >
          <BiEdit style={{ color: "green" }} size={18} />
        </Link>
      ) : null,
      // Use edit icon for other statuses
    );
    value["action"] = buttons.length > 0 ? buttons : "-";
    return value;
  });

  return (
    <>
      <div className="row">
        <div className="col mb-3  text-center">
          <div className="row mb-4">
            <div className="col-md-6 col-sm-12">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
                placeholder="Search By number"
              />
            </div>

            <div className="col-sm-12 col-md-6 d-flex flex-row-reverse mt-2">
              <div className="float-left  ml-3">
                <label className="mr-2 ">Show</label>
                <select
                  name="list_length"
                  className="form-select "
                  onChange={changeItemsPerPage}
                >
                  {filterListLengths.map((value, key) => {
                    return (
                      <option key={++key} value={value}>
                        {value}
                      </option>
                    );
                  })}
                </select>
                <span className="ml-2 ">entries</span>
              </div>
            </div>
          </div>

          {/* <table className="table table-striped table-hover table-vcenter text-nowrap mb-0 "> */}
          <div
            className="table-responsive"
            style={{ border: "1px solid #000" }}
          >
            <table
              className="table table-hover table-fixed"
              style={{ border: "none" }}
            >
              <TableHeader
                headers={headers}
                // onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {newData.map((comment, idx) => {
                  return (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor:
                          comment?.line_break === "1" ? "#f8d7da" : "", // Conditional background color
                        cursor: "pointer", // Add pointer cursor for hover effect
                      }}
                      title={
                        comment?.line_break === "1"
                          ? "Remove space in tally for this dealer"
                          : ""
                      } // Text to show on hover
                    >
                      <td style={{ textAlign: "left" }}>
                        {idx + (currentPage - 1) * 10 + 1}
                      </td>
                      {/* Serial number data */}
                      {headers.map((col, colIdx) =>
                        col.field !== "image" ? (
                          <td
                            key={`${idx}-${colIdx}`}
                            style={{
                              textAlign: "left",
                            }}
                          >
                            {isValidURL(comment[col.field])
                              ? `${comment[col.field]
                                  ?.split("/")
                                  ?.pop()
                                  ?.split("-")
                                  ?.slice(1)
                                  ?.join("-")}`
                              : comment[col.field]}
                          </td>
                        ) : (
                          <td
                            key={`${idx}-${colIdx}`}
                            style={{ textAlign: "left" }}
                          >
                            <img
                              src={comment[col.field]}
                              style={{ width: "90px", height: "90px" }}
                            />
                          </td>
                        ),
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 d-flex justify-content-center align-items-center">
        <Pagination
          total={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>{" "}
    </>
  );
};

export default OrderTable;
